import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Spacer } from '../components/common/Decorations';
import '../styles/BiographyPage.css';
import { useEffect } from 'react';


const HomePage = () => {
  console.log("Loaded BiographyPage")
  const [activeTab, setActiveTab] = useState('biography');
  const [biography, setBiographyData] = useState(null);

  useEffect(() => {
      // Загрузка данных с бэкенда
      fetch('/api/biography/list')
      .then(res => res.json())
      .then(data => {
          setBiographyData(data);
      })
      .catch(error => {
          console.error('Ошибка загрузки данных:', error);
          setBiographyData({
          current_page: "experience",
          stack_summary: [],
          experiences: []
          });
      });
  }, []);

  if (!biography) {
      return <div>Загрузка...</div>;  // Лоадер, пока данные грузятся
  }

  console.log(biography)

  // const biography = [
  //   {
  //     title: "ДО IT",
  //     content: "Я родился в небольшом городке Беларуси.\nВ 2010 переехал в Санкт-Петербург учиться. Поступил на бюджет в НИУ ИТМО, но разочаровался в качестве обучения и пошел работать.\nСледующие десять лет я постигал искусство коммуникаций, продавал все от наушников до квартир. Прошел срочную службу. Работал тренером по продажам, руководителем офисов продаж и затем мастером по ремонту портативной электроники.\nИ однажды я задал себе вопрос \"А что дальше?\"",
  //     image: "https://ilyashirko.dev/media/first_TxZeUgk.jpg"
  //   },
  //   {
  //     title: "МОЙ ПУТЬ В IT",
  //     content: "Перед тем как начать учиться у профессионалов, я решил организовать себе своего рода вступительное испытание.\nМоему другу понадобился парсер и я вызвался написать его. Не самый легкий парсер для новичка, почти каждый шаг пришлось постигать с нуля.\nЯ ничего не знал о базах данных, все хранил в .txt файлах, не знал как правильно хранить токены, не знал что такое зависимости и как хранить информацию о них.\nТем не менее я написал этот парсер, потратив пару недель. Было интересно, но не достаточно и тогда я решил взяться за большой телеграм бот.",
  //     image: "https://ilyashirko.dev/media/third_gV0QuMY.jpg"
  //   },
  //   {
  //     title: "БОЛЬШОЙ ТЕЛЕГРАМ БОТ",
  //     content: "Бот был на кулинарную тематику.\nРандомный рецепт по категориям на вечер, меню на день/неделю/месяц с генерацией списка покупок, избранное, черный список (как блюд, так и ингредиентов), админка прямо в телеграме, отдельное меню для модерации...\nБот получился классный.\nПотратил месяца три на него, добился того что почти ничего не падало (напомню, все еще ни слова о best-practice).\nОбратился к опытному разработчику за ревью, два часа листали мои 3500 строк кода, получил 36 замечаний и понял что пора.\nТак я оказался в школе программистов.",
  //     image: "https://ilyashirko.dev/media/e8f85a18092c21000adcb3ac81295c90.jpg"
  //   }
  // ]
  
  return (
    <div>
      <Header currentPage={"biography"} />
      <div className='content'>
        <div className="title"><strong>ОБО МНЕ</strong></div>

        {biography.map((content, index) => (
          <React.Fragment key={index}>
            {index % 2 === 0 ? (
              <div className="biographyContentLeft">
                <div className="biographyChapter">
                  <span className="biographyTitle"><strong>{content.title}</strong></span>
                  {content.content.split('\n').map((item, i) => (
                    <p key={i} className="biographyItem">{item}</p>
                  ))}
                </div>
                <div className="biographyImage" style={{ backgroundImage: `url(${content.image})`, backgroundPosition: 'right' }}></div>
              </div>
            ) : (
              <div className="biographyContentRight">
                <div className="biographyImage" style={{ backgroundImage: `url(${content.image})`, backgroundPosition: 'left' }}></div>
                <div className="biographyChapter">
                  <span className="biographyTitle"><strong>{content.title}</strong></span>
                  {content.content.split('\n').map((item, i) => (
                    <p key={i} className="biographyItem">{item}</p>
                  ))}
                </div>
              </div>
            )}
            {index !== biography.length - 1 && <hr />}
          </React.Fragment>
        ))}
        
        
      </div>
      <Spacer height={50}/>
      <Footer />
    </div>
  );
};

export default HomePage;